import React from 'react';
import { Navigate } from 'react-router';
import useAuth from '@hooks/useAuth';
import OnboardingModal from '@components/onboarding/OnboardingModal';
import useUser from '@hooks/useUser';
import { CircularProgress, Grid2 } from '@mui/material';

export default function AuthGuard({ children }: { children: React.JSX.Element }) {
    const { authUser, loading: authLoading } = useAuth();
    const { user, loading: userLoading } = useUser();

    // FIXME: This is a temporary solution to check if the user is approved by the super coach.
    // const isApprovedBySuperCoach = Boolean(true);
    // const role = auth?.role;

    // const redirectionUrl = window.location.href;
    // if (redirectionUrl.includes('/event-details') && !user) {
    //     return <Navigate to={`/auth?redirect=${redirectionUrl}`} />;
    // }

    // console.log(`[AuthGuard] authUser`, { authUser, user, authLoading, userLoading });

    if (authLoading || userLoading) {
        return (
            <Grid2 paddingX={'49vw'} paddingY={'45vh'}>
                <CircularProgress color="secondary" size={40} />
            </Grid2>
        );
    }

    if (!authUser) {
        return (
            <Navigate
                // Save the current URL to redirect back after login
                to={`/auth?returnTo=${encodeURI(window.location.pathname + (window.location.search || ''))}`}
            />
        );
    }

    // Is the user missing their first or last name?
    const missingUserName = !user?.firstName || !user?.lastName;

    // If user has not provided their first and last name, show onboarding modal
    if (missingUserName) {
        return <OnboardingModal />;
    }

    // if (!isApprovedBySuperCoach) {
    //     return <NotVerified />;
    // }

    return children;
}
